import { render, staticRenderFns } from "./lifehall.vue?vue&type=template&id=7889648b&scoped=true"
import script from "./lifehall.vue?vue&type=script&lang=js"
export * from "./lifehall.vue?vue&type=script&lang=js"
import style0 from "./lifehall.vue?vue&type=style&index=0&id=7889648b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889648b",
  null
  
)

export default component.exports